import React from "react";
import { Link } from "react-router-dom";

import { useRoutes } from "utils/routes";
import { useFeature } from "components/OrganizationFeatures";
import TreeMap from "components/TreeMap";
import Loading from "components/Loading";

import { useTableTreeMapQuery } from "./gql/Query.generated";
import styles from "./style.module.scss";

type Props = {
  databaseId: string;
  organizationSlug: string;
};

const TableTreeMap: React.FunctionComponent<Props> = ({
  databaseId,
  organizationSlug,
}) => {
  const { organizationSubscription, databaseTable } = useRoutes();
  const hasSchemaStatsFeature = useFeature("schemaStats");
  const { error, loading, data } = useTableTreeMapQuery({
    variables: {
      databaseId,
    },
  });
  if (loading || error) {
    return <Loading error={!!error} />;
  }
  const schemaTables = data.getSchemaTables;

  if (!hasSchemaStatsFeature) {
    return (
      <div className={styles.schemaStatsUnavailable}>
        <p>
          <strong>Schema Statistics</strong> are not included in your current
          plan.
          <br />
          <Link to={organizationSubscription(organizationSlug)}>
            Learn more about our Production plans.
          </Link>
        </p>
      </div>
    );
  }

  const treeMapData = schemaTables.map((t) => ({
    displayName: t.tableName,
    name: `${t.schemaName}.${t.tableName}`,
    link: databaseTable(databaseId, t.id),
    size: t.lastStats?.dataSizeBytes || 0,
  }));

  return <TreeMap data={treeMapData} />;
};

export default TableTreeMap;
